import Component from '@glimmer/component';

export default class VoucherListValueComponent extends Component {}
